/**
 * @author Brendan Magee
 * @description Simple service for task trigger CRUD actions
 */

function taskTriggersService($http, Task) {
  const service = {
    triggerContainer: {
      type: 'workflow_status_change'
    }
  };

  service.getTriggers = params => $http.get('api/tasks/triggers', { params })
    .then((response) => {
      if (!response.data || !response.data.results) { return []; }

      response.data.results = response.data.results.map(
        trigger => ({
          ...trigger,
          task: new Task(trigger.task)
        })
      );

      return response.data.results;
    }
    );

  service.getTrigger = triggerId => $http.get(`api/tasks/triggers/${triggerId}`)
    .then(response => response.data);

  service.saveTrigger = (trigger = {}) => {
    const triggerToSubmit = { ...service.triggerContainer, ...trigger };

    let method = 'POST';
    let endpoint = 'api/tasks/triggers';

    if (trigger.id !== undefined && trigger.id !== null) {
      method = 'PUT';
      endpoint += `/${trigger.id}`;
    }

    return $http({
      method,
      url: endpoint,
      data: triggerToSubmit
    })
      .then(response => response.data);
  };

  service.deleteTrigger = triggerId => $http.delete(`api/tasks/triggers/${triggerId}`)
    .then(response => response.data);

  return service;
}

const arr = [
  '$http',
  'Task',
  taskTriggersService
];

module.exports = (ngModule) => {
  ngModule.factory('taskTriggersService', arr);
};
